export default "__VITE_ASSET__D_1MpL4M__"